import React from 'react';
import { Layout, Typography, Divider } from 'antd';
import ReportCDR from './reports/ReportCDR';

const { Content } = Layout;
const { Title, Text } = Typography;

const ReportsPage = () => {
    return (
        <Layout style={{ minHeight: '100%', background: 'transparent' }}>
            {/* Directly show CDR Report without selector */}
            <Content className="fade-in">
                <div style={{ marginBottom: 16, display: 'flex', flexDirection: 'column' }}>
                    <Title level={4} style={{ margin: 0 }}>Detalle de Llamadas (CDR)</Title>
                    <Text type="secondary" style={{ fontSize: 13 }}>Listado detallado de todas las llamadas entrantes y salientes.</Text>
                </div>

                <Divider style={{ margin: '0 0 24px 0' }} />

                <div className="report-container fade-in">
                    <ReportCDR />
                </div>
            </Content>
        </Layout>
    );
};

export default ReportsPage;
